import { createRefreshScheduler, RefreshContext } from './refreshScheduler'

type MercureRefreshData = { eventType?: string; event?: string; massNotificationId?: string }
type RefreshOptions = {
  delayMs?: number
  waitForFilters?: boolean
  eventSource?: Pick<EventSource, 'addEventListener' | 'removeEventListener'>
}

/** Use only for reloads. Payload-based updates retain their normal Mercure listener. */
export function subscribeMercureRefresh (
  matches: (data: MercureRefreshData) => boolean,
  refresh: 'page' | ((context: RefreshContext) => PromiseLike<unknown>),
  { delayMs, waitForFilters = false, eventSource }: RefreshOptions = {}
) {
  const scheduler = createRefreshScheduler(refresh === 'page' ? async () => {
    subscription.dispose()
    window.location.reload()
  } : refresh, delayMs)
  const listener = (event: CustomEvent) => {
    if (event.detail?.data && matches(event.detail.data)) scheduler.request()
  }
  const onMessage = (event: MessageEvent) => {
    const data = JSON.parse(event.data)
    if (data && matches(data)) scheduler.request()
  }
  const onPageHide = (event: PageTransitionEvent) => {
    if (!event.persisted) subscription.dispose()
  }
  window.addEventListener('pagehide', onPageHide)
  if (eventSource) {
    eventSource.addEventListener('message', onMessage)
  } else {
    document.addEventListener('MercureEvent', listener)
  }
  if (waitForFilters) {
    document.addEventListener('FilterRequestStarted', scheduler.pause)
    document.addEventListener('FilterRequestFinished', scheduler.resume)
  }

  const subscription = {
    ...scheduler,
    dispose () {
      window.removeEventListener('pagehide', onPageHide)
      document.removeEventListener('MercureEvent', listener)
      eventSource?.removeEventListener('message', onMessage)
      document.removeEventListener('FilterRequestStarted', scheduler.pause)
      document.removeEventListener('FilterRequestFinished', scheduler.resume)
      scheduler.dispose()
    }
  }
  return subscription
}
